import React, { Component, Fragment } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import alasql from "alasql";
import moment from "moment";
import Statistic from "./statistic/statistics";
import RiskStatistic from "./RiskStatistic/RiskStatistic";
import MonthlyTable from "./MonthlyReturns/monthlyTable";
import WithCard from "../../../common/withCard";
import DrawDown from "./drawDown";
import DownloadPdfButton from "../../../common/buttons/downloadPdfButton";
import Helper from "../performance/helper";
import "./statistics.scss";
import {
  StyleSheet,
  Image as IMG,
  View,
  Document,
  Page,
  Text,
  pdf,
} from "@react-pdf/renderer";
import PDFHelper from "../../../parts/pdfmaker/pdf.helper";
import { pdfStyles } from "../Component page/pdf.styles";
import PdfHeader from "../../../parts/pdfmaker/common/pdfHeader";
import PdfTable from "../../../parts/pdfmaker/common/pdfTable";
import pdfLegend from "../../../parts/pdfmaker/common/pdfLegend";

class Statistics extends Component {
  state = {
    monthly_returns_table_heading: [
      { title: "Year" },
      { title: "" },
      { title: "Jan" },
      { title: "Feb" },
      { title: "Mar" },
      { title: "Apr" },
      { title: "May" },
      { title: "Jun" },
      { title: "Jul" },
      { title: "Aug" },
      { title: "Sep" },
      { title: "Oct" },
      { title: "Nov" },
      { title: "Dec" },
      { title: "YTD" },
    ],
    getBacktest: [],
    lastTableData: [],
    getRiskStatistics: [],
    orig_getPerfHistMetrics: [],
    risk_table_columns: [],
    risk_table_rows: [],
    Scatter_chart_data: [],
    monthly_table_rows: [],
    monthly_table_rows2: [],
    monthly_return_table: false,
    pdf_legends: [],
    colors: ["#81efde", "#4c6ead", "#8775a7"],
  };

  componentWillMount() {
    const { riskStatistics, model_name, typeName } = this.props;

    if (
      this.props.getRiskStatistics &&
      this.props.getRiskStatistics.length > 0
    ) {
      this.setState({
        getRiskStatistics: this.props.getRiskStatistics,
      });

      this.risk_statistics_table_data({
        getRiskStatistics: this.props.getRiskStatistics,
        riskStatistics,
        model_name,
        typeName,
      });
    }
  }
  componentDidMount() {
    const {
      getBacktest,
      getPerfHistMetrics,
      analyze_compare,
      riskStatistics,
      model_name,
      typeName,
      display_orig_portfolio,
      client_getPerfHistmetrics,
    } = this.props;
    const { getRiskStatistics } = this.state;
    if (getBacktest) {
      this.setState({
        getBacktest,
        lastTableData: getPerfHistMetrics,
      });
    }
    if (getRiskStatistics) {
      this.risk_statistics_table_data({
        getRiskStatistics,
        riskStatistics,
        model_name,
        typeName,
      });
    }

    // setting original perf Histmetrics
    if (analyze_compare && analyze_compare.getPerfHistmetrics.length > 0) {
      this.setState({
        orig_getPerfHistMetrics: analyze_compare.getPerfHistMetrics,
      });
    }

    // scatter chart setting data
    this.setScatterChartData({
      getBacktest,
      analyze_compare,
      display_orig_portfolio,
    });

    // monthly table data
    this.setMonthlyTableData({
      iqcio_data: getPerfHistMetrics,
      orig_data: client_getPerfHistmetrics,
      typeName,
      display_orig_portfolio,
      model_name,
    });

    // setting pdf legends
    let pdf_legends = [];
    if (display_orig_portfolio) {
      pdf_legends.push(
        "IQCIO Portfolio +",
        "Benchmark *",
        "Original Portfolio"
      );
    } else {
      pdf_legends.push("Portfolio", "Benchmark");
    }
    this.setState({
      pdf_legends,
    });

    // setting get risk statistics table
    if (
      this.props.getRiskStatistics &&
      this.props.getRiskStatistics.length > 0
    ) {
      this.setState({
        getRiskStatistics: this.props.getRiskStatistics,
      });

      this.risk_statistics_table_data({
        getRiskStatistics: this.props.getRiskStatistics,
        riskStatistics,
        model_name,
        typeName,
      });
    }
  }
  componentWillReceiveProps(nextProps) {
    const {
      getBacktest,
      getPerfHistMetrics,
      scenario_id,
      type,
      riskStatistics,
      model_name,
      typeName,
      analyze_compare,
      display_orig_portfolio,
      client_getPerfHistmetrics,
    } = nextProps;

    const { getRiskStatistics } = this.state;

    if (getBacktest) {
      this.setState({
        getBacktest,
        lastTableData: getPerfHistMetrics,
      });
    }

    if (
      (analyze_compare.hasOwnProperty("riskStatistics") &&
        nextProps.getRiskStatistics.length > 0) ||
      JSON.stringify(this.props.getRiskStatistics) !=
        JSON.stringify(nextProps.getRiskStatistics)
    ) {
      this.setState({
        getRiskStatistics: nextProps.getRiskStatistics,
      });

      this.risk_statistics_table_data({
        getRiskStatistics: nextProps.getRiskStatistics,
        riskStatistics,
        model_name,
        typeName,
      });
    }

    // setting original perf Histmetrics
    if (analyze_compare && analyze_compare.getPerfHistmetrics.length > 0) {
      this.setState({
        orig_getPerfHistMetrics: analyze_compare.getPerfHistMetrics,
      });
    }

    // scatter chart setting data
    this.setScatterChartData({
      getBacktest,
      analyze_compare,
      display_orig_portfolio,
    });

    // monthly table data
    this.setMonthlyTableData({
      iqcio_data: getPerfHistMetrics,
      orig_data: client_getPerfHistmetrics,
      typeName,
      display_orig_portfolio,
      model_name,
    });

    // setting pdf legends
    if (this.props.display_orig_portfolio !== display_orig_portfolio) {
      let pdf_legends = [];
      if (display_orig_portfolio) {
        pdf_legends.push(
          "IQCIO Portfolio +",
          "Benchmark *",
          "Original Portfolio"
        );
      } else {
        pdf_legends.push("Portfolio", "Benchmark");
      }

      this.setState({
        pdf_legends,
      });
    }
  }

  // =========== risk statistics table ===============
  risk_statistics_table_data = ({
    getRiskStatistics,
    riskStatistics,
    model_name,
    typeName,
  }) => {
    // adding one more column if flow is from create  portfolio ajax_compare_portfolio
    let mergeData;
    let tableListOfArrays;
    let columns;

    if (riskStatistics && riskStatistics.length > 0) {
      mergeData = Helper.mergeData(getRiskStatistics, riskStatistics);
      tableListOfArrays = Helper.portfolioReturnDataModify(mergeData);
      let iqcio_portfolio = `IQCIO Model ${model_name ? "+" : ""}`;
      columns = [
        { title: "Risk" },
        { title: iqcio_portfolio },
        { title: `Benchmark *` },
        { title: "Original Portfolio" },
      ];
    } else {
      mergeData = Helper.mergeData(getRiskStatistics, riskStatistics);
      tableListOfArrays = Helper.portfolioReturnDataModify(mergeData);
      columns = [
        { title: "Risk" },
        { title: "Portfolio" },
        { title: `${typeName}` },
      ];
    }

    this.setState({
      risk_table_rows: tableListOfArrays,
      risk_table_columns: columns,
    });
  };
  // ============ monthly table ==============
  setMonthlyTableData = ({
    iqcio_data,
    orig_data,
    typeName,
    display_orig_portfolio,
    model_name,
  } = []) => {
    // sorting data based on metric_name
    if (iqcio_data) {
      iqcio_data = alasql("SELECT * FROM ? ORDER BY metric_name DESC", [
        iqcio_data,
      ]);
    }

    if (orig_data) {
      orig_data = alasql("SELECT * FROM ? ORDER BY metric_name DESC", [
        orig_data,
      ]);
    }

    let rows = [];
    let newData = [];
    if (iqcio_data.length) {
      for (let i in iqcio_data) {
        let line = iqcio_data[i];

        if (
          line.metric_name.length !== 4 ||
          (line.metric_name.length === 4 &&
            !moment(line.metric_name, "YYYY").isValid())
        )
          continue;

        let portfolio_name = display_orig_portfolio
          ? `IQCIO Portfolio ${model_name ? "+" : ""}`
          : "Portfolio";
        let benchmarkOrType = display_orig_portfolio
          ? "Benchmark *"
          : typeName
          ? typeName
          : "Benchmark";
        let row = [line.metric_name, ""];
        let portfolio = ["", portfolio_name];
        let benchmark = ["", benchmarkOrType];
        let orig_portfolio = ["", "Original Portfolio"];

        for (let j = 1; j <= 12; j++) {
          const date = moment(j + "-" + line.metric_name, "M-YYYY").format(
            "MM-YYYY"
          );
          const res = alasql(
            "select * from ? where metric_name = '" + date + "'",
            [iqcio_data]
          );

          if (!res.length) {
            row.push("");
            portfolio.push("");
            benchmark.push("");
          } else {
            row.push(" ");
            portfolio.push(
              res[0].fund_return !== null
                ? (parseFloat(res[0].fund_return) * 100).toFixed(2) + "%"
                : ""
            );
            benchmark.push(
              res[0].bm_return !== null
                ? (parseFloat(res[0].bm_return) * 100).toFixed(2) + "%"
                : ""
            );
          }

          // orig
          if (orig_data && orig_data.length) {
            const original_portfolio_res = alasql(
              "select * from ? where metric_name = '" + date + "'",
              [orig_data]
            );

            if (!original_portfolio_res.length) {
              orig_portfolio.push("");
            } else {
              orig_portfolio.push(
                original_portfolio_res[0].fund_return !== null
                  ? (
                      parseFloat(original_portfolio_res[0].fund_return) * 100
                    ).toFixed(2) + "%"
                  : ""
              );
            }
          }
        }

        const ytd = alasql(
          "select * from ? where metric_name = '" + line.metric_name + "'",
          [iqcio_data]
        );

        if (!ytd.length) {
          row.push("");
          portfolio.push("");
          benchmark.push("");
        } else {
          row.push("");
          portfolio.push(
            ytd[0].fund_return !== null
              ? (parseFloat(ytd[0].fund_return) * 100).toFixed(2) + "%"
              : `-`
          );
          benchmark.push(
            ytd[0].bm_return !== null
              ? (parseFloat(ytd[0].bm_return) * 100).toFixed(2) + "%"
              : ""
          );

          //orig
          if (orig_data && orig_data.length) {
            const ytd2 = alasql(
              "select * from ? where metric_name = '" + line.metric_name + "'",
              [orig_data]
            );
            if (!ytd2.length) {
              orig_portfolio.push("-");
            } else {
              orig_portfolio.push(
                ytd2[0].fund_return !== null
                  ? (parseFloat(ytd2[0].fund_return) * 100).toFixed(2) + "%"
                  : `-`
              );
            }
          }
        }

        if (orig_data && orig_data.length > 0) {
          // newData.push(row, portfolio, benchmark, orig_portfolio);
          newData.push(row, portfolio, benchmark, orig_portfolio);
        } else {
          rows.push(row, portfolio, benchmark);
        }
      }
      if (display_orig_portfolio && orig_data && newData.length > 0) {
        this.setState({
          monthly_table_rows: [],
          monthly_table_rows2: newData,
          monthly_return_table: true,
        });
      } else if (rows.length > 0) {
        this.setState({
          monthly_table_rows: rows,
          monthly_table_rows2: [],
          monthly_return_table: true,
        });
      }
    } else {
      this.setState({
        monthly_return_table: false,
      });
    }
  };
  // ============ scatter chart ==============
  setScatterChartData = ({
    getBacktest,
    analyze_compare,
    display_orig_portfolio,
  } = []) => {
    if (Object.keys(getBacktest).length) {
      let { getBenchmarkVami, getPortfolioVami } = getBacktest;
      let BenchmarkData = getBenchmarkVami.map((d) => {
        return [new Date(d.dt), d.vami * 1];
      });
      let PortfolioData = getPortfolioVami.map((d) => {
        return [new Date(d.dt), d.vami * 1];
      });

      if (
        display_orig_portfolio &&
        analyze_compare.clientBacktestData.getPortfolioVami
      ) {
        let portfolio_original = analyze_compare.clientBacktestData.getPortfolioVami.map(
          (e) => {
            return [new Date(e.dt), e.vami * 1];
          }
        );

        this.setState({
          Scatter_chart_data: [
            {
              data: PortfolioData,
              label: "IQCIO Portfolio",
            },
            {
              data: portfolio_original,
              label: "Orginal Portfolio",
            },
          ],
        });
      } else {
        this.setState({
          Scatter_chart_data: [
            {
              data: PortfolioData,
              label: "Portfolio",
            },
            {
              data: BenchmarkData,
              label: "Benchmark",
            },
          ],
        });
      }
    }
  };
  // =========================================
  exportToPDF = () => {
    const {
      risk_table_rows,
      risk_table_columns,
      monthly_returns_table_heading,
      monthly_table_rows,
      monthly_table_rows2,
      pdf_legends,
      colors,
    } = this.state;
    const { getBacktest } = this.props;
    let heading = "";
    if (getBacktest) {
      heading = this.props.heading
        ? this.props.heading
        : getBacktest["getPortfolioMetrics"][0]["scenario_name"];
    }

    Promise.all([PDFHelper.svgToPng("areaChart_01")]).then((value) => {
      const styles = StyleSheet.create({
        ...pdfStyles,
      });
      let text_style = {
        color: "#223279",
        textAlign: "center",
        paddingTop: 5,
        paddingBottom: 5,
      };
      const MyDoc = () => (
        <Document>
          <Page size="A4" wrap style={styles.pb}>
            <PdfHeader mainHeading={heading + " - " + "STATISTICS"} />
            <View style={styles.paddingHorizontal}>
              <View style={{ marginTop: 20 }}>
                <View style={text_style}>
                  <Text>RISK STATISTICS</Text>
                </View>
                <View>
                  <PdfTable
                    data={risk_table_rows}
                    heading={risk_table_columns}
                    Width={risk_table_columns.length == 3 ? "33.33%" : "25%"}
                  />
                </View>
              </View>
              <View style={{ marginTop: 40 }}>
                <View style={text_style}>
                  <Text>DRAWDOWN</Text>
                </View>
                <View>
                  <View>
                    {pdfLegend({
                      data_list: pdf_legends,
                      colors: colors,
                    })}
                  </View>
                  <IMG source={value[0]}></IMG>
                </View>
              </View>
            </View>
          </Page>
          <Page size="A4" wrap style={styles.pb}>
            <View style={styles.paddingHorizontal}>
              <View style={{ marginTop: 20 }}>
                <View style={text_style}>
                  <Text>MONTHLY RETURNS</Text>
                </View>
                <View>
                  <PdfTable
                    data={
                      monthly_table_rows2.length > 0
                        ? monthly_table_rows2
                        : monthly_table_rows
                    }
                    heading={monthly_returns_table_heading}
                    Width={"6.66%"}
                  />
                </View>
              </View>
            </View>
          </Page>
        </Document>
      );
      pdf(<MyDoc />)
        .toBlob()
        .then((blob) => {
          const link = document.createElement("a");
          // create a blobURI pointing to our Blob
          link.href = URL.createObjectURL(blob);
          link.download = "statistics.pdf";
          // some browser needs the anchor to be in the doc
          document.body.append(link);
          link.click();
          link.remove();
        });
    });
  };
  render() {
    const {
      getBacktest,
      lastTableData,
      getRiskStatistics,
      orig_getPerfHistMetrics,
      risk_table_columns,
      risk_table_rows,
      monthly_returns_table_heading,
      Scatter_chart_data,
      monthly_table_rows,
      monthly_table_rows2,
      monthly_return_table,
    } = this.state;
    const {
      lastTableDisplay,
      groupDonutChart,
      benchmark_name,
      analyze_compare,
      display_orig_portfolio,
      client_portfolio_vami,
      riskStatistics,
      model_name,
      typeName,
      client_getPerfHistmetrics,
    } = this.props;

    const { getBenchmarkVami, getPortfolioVami } = getBacktest;

    return (
      <div className="risk_statistics">
        <Fragment>
          {getRiskStatistics ? (
            <WithCard>
              <div className="row">
                <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12 risk_statistics_download_btn">
                  <DownloadPdfButton handler={this.exportToPDF} />
                </div>
              </div>
            </WithCard>
          ) : null}
          {groupDonutChart ? (
            <WithCard>
              {Object.keys(getBacktest).length ? (
                <Statistic
                  {...this.props}
                  getRiskStatistics={getRiskStatistics}
                />
              ) : null}
            </WithCard>
          ) : null}
          <WithCard>
            {getRiskStatistics.length ? (
              <RiskStatistic
                getRiskStatistics={getRiskStatistics}
                // riskStatistics={riskStatistics}
                typeName={typeName}
                benchmark_name={benchmark_name}
                model_name={model_name}
                display_orig_portfolio={display_orig_portfolio}
                risk_table_columns={risk_table_columns}
                risk_table_rows={risk_table_rows}
              />
            ) : null}
          </WithCard>
          {lastTableDisplay ||
          (orig_getPerfHistMetrics && orig_getPerfHistMetrics.length > 0) ||
          (monthly_table_rows && monthly_table_rows.length) ||
          (monthly_table_rows2 && monthly_table_rows2.length) ? (
            <Fragment>
              {lastTableData.length ? (
                <WithCard>
                  <MonthlyTable
                    lastTableData={lastTableData}
                    {...this.props}
                    orig_getPerfHistMetrics={orig_getPerfHistMetrics}
                    benchmark_name={benchmark_name}
                    display_orig_portfolio={display_orig_portfolio}
                    model_name={model_name}
                    analyze_compare={analyze_compare}
                    client_getPerfHistmetrics={client_getPerfHistmetrics}
                    monthly_returns_table_heading={
                      monthly_returns_table_heading
                    }
                    Scatter_chart_data={Scatter_chart_data}
                    monthly_table_rows={monthly_table_rows}
                    monthly_table_rows2={monthly_table_rows2}
                    monthly_return_table={monthly_return_table}
                  />
                </WithCard>
              ) : null}
            </Fragment>
          ) : null}
          {getBenchmarkVami &&
          getPortfolioVami &&
          display_orig_portfolio == false ? (
            <DrawDown
              getBenchmarkVami={getBenchmarkVami}
              getPortfolioVami={getPortfolioVami}
              benchmark_name={benchmark_name}
            />
          ) : null}

          {getPortfolioVami &&
          display_orig_portfolio == true &&
          client_portfolio_vami &&
          client_portfolio_vami.length > 0 ? (
            <DrawDown
              getBenchmarkVami={getBenchmarkVami}
              getPortfolioVami={getPortfolioVami}
              getOrigPortfolioVami={client_portfolio_vami}
              benchmark_name={benchmark_name}
              display_orig_portfolio={display_orig_portfolio}
              model_name={model_name}
            />
          ) : null}
        </Fragment>
      </div>
    );
  }
}

Statistic.prototype = {
  typeName: PropTypes.string.isRequired,
  getBacktest: PropTypes.object.isRequired,
  getPerfHistMetrics: PropTypes.arrayOf(PropTypes.object).isRequired,
  getRiskStatistics: PropTypes.arrayOf(PropTypes.object).isRequired,
};
export default connect(
  ({
    create: {
      steps: {
        universeLite: { analyze_compare, model_name },
        risk: { benchmark_name, display_orig_portfolio },
      },
    },
  }) => ({
    analyze_compare,
    display_orig_portfolio,
    client_portfolio_vami: analyze_compare.clientBacktestData.getPortfolioVami,
    client_getPerfHistmetrics: analyze_compare.getPerfHistmetrics,
    benchmark_name,
    model_name,
    riskStatistics: analyze_compare.riskStatistics,
  }),
  null
)(Statistics);



// WEBPACK FOOTER //
// ./src/components/PortfolioDashboard/navigationPages/statistics/statistics.jsx